import useAssets from '../../../../../common/useAssets';
// const cdn = useAssets(false);

export const growList = [
    {index: 1, title: '高标准严要求', content: '始终保持较高的自我要求，拥有很好的时间管理和清晰的职业规划，不钻规则的漏洞，致力于追求个人能力的持续提高。'},
    {index: 2, title: '主动且正能量', content: '总是很主动的表达自己的观点、给别人提供帮助、承担职责以外的工作职责扛得住压力，总能消化负面绪，也能感染他人正能量的看待人和事，困境对他们来说是挑战而不是阻碍。'},
    {index: 3, title: '靠谱的行动力', content: '凡事有交代、件件有着落、事事有回应行动前先思考，知道“为什么做”，不是“为了做而做”具备独立判断能力，善于利用方法及工具应对工作中出现的问题。'},
    {index: 4, title: '坚持目标导向', content: '每项工作都会树立清晰的目标，制定详细的计划，并通过各种努力最终拿到结果总有一股不达目的不罢休的劲头。'},
    {index: 5, title: '善于协作补位', content: '以团队利益为先，乐于助人，充分信任伙伴合作时出了问题不推诿责任而是先去解决问题，工作有成绩时也不抢功。'},
]